export default "__VITE_ASSET__BgMInOoG__"